// Cipher v1.1 shell feature flag (default OFF).
//
// Mirrors `components/brain/flag.js` exactly, and for the same reason: when
// false, App.js does NOT register the /v2/* route and the existing application
// is byte-identical. That property is what makes overnight work on the v1.1
// shell safe while every v1 screen stays mounted and reachable (R1, R2, R3).
//
// `String(undefined).toLowerCase()` is "undefined", not "true", so an unset
// variable reads as OFF. Anything other than the literal string "true" is OFF.
export const V2_ENABLED =
  String(process.env.REACT_APP_CIPHER_V2).toLowerCase() === "true";
